import { createRequest, throwResErrors, createHeaders } from "./requestUtil";

export function getEstimatedPriceAndMarketIndexes(data) {
	let url = `/api/calculator/market_indexes`;
	return createRequest()
		.post(url, data, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
}
